import React from 'react';
import PopupOffline from '../../components/PopupOffline/PopupOffline';
import { useAppContext } from '../../contexts/AppContext';

import './Offline.css'; 

const Offline = () => {

  const { appRef } = useAppContext();
  const customer_barcode = appRef.current.state.user_data?.customer_code || '';

  return <div className={`container page_offline no-animation`}>
    <div className="content">
      <PopupOffline customer_barcode={customer_barcode} />
    </div>
  </div>;
};

export default Offline;
